import React from 'react';
import IJTLLogoProps from './IJTLLogoProps';

const JTLLogo: React.FC<IJTLLogoProps> = ({ size = 'default' }) => {
  return (
    <>
      {size === 'default' ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="76" height="56" viewBox="0 0 76 56" fill="none">
          <g clipPath="url(#clip0_9073_195631)">
            <path
              d="M67.5004 0H7.68666C3.43825 0 0 3.43825 0 7.68666V48.3133C0 52.5618 3.43825 56 7.68666 56H67.5102C71.7586 56 75.1969 52.5618 75.1969 48.3133V7.68666C75.187 3.43825 71.7488 0 67.5004 0ZM29.1362 40.6168C29.1362 44.3811 28.3458 46.7523 26.7848 47.6909C25.7177 48.3331 23.139 48.6493 19.108 48.6493C15.808 48.6493 13.6443 48.1355 12.686 47.1277C11.7276 46.1101 11.2336 43.9266 11.2336 40.6168V31.9125H18.94V40.0635C18.94 41.8123 19.6316 42.1778 20.2145 42.1778C20.6888 42.1778 21.2717 41.9308 21.3903 40.7255V9.17855H29.1362V40.6168ZM46.7227 15.4227H42.8497V48.4912H35.0939V15.4227H31.2209V9.17855H46.7325V15.4227H46.7227ZM61.7502 48.4912H49.3507V9.17855H57.0473V42.0198H61.7601V48.4912H61.7502Z"
              fill={'var(--base-shaftblue)'}
            />
            <path
              d="M29.1362 40.6168C29.1362 44.3811 28.3458 46.7523 26.7847 47.6909C25.7177 48.3331 23.139 48.6492 19.108 48.6492C15.808 48.6492 13.6443 48.1355 12.6859 47.1277C11.7276 46.1101 11.2336 43.9266 11.2336 40.6168V31.9125H18.94V40.0635C18.94 41.8123 19.6316 42.1778 20.2145 42.1778C20.6888 42.1778 21.2717 41.9308 21.3903 40.7255V9.17853H29.1362V40.6168ZM46.7226 15.4227H42.8497V48.4912H35.0938V15.4227H31.2209V9.17853H46.7325V15.4227H46.7226ZM61.7502 48.4912H49.3507V9.17853H57.0473V42.0197H61.76V48.4912H61.7502Z"
              fill={'var(--base-logo-white)'}
            />
          </g>
          <defs>
            <clipPath id="clip0_9073_195631">
              <rect width="75.1969" height="56" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width="49" height="36" viewBox="0 0 49 36" fill="none">
          <g clipPath="url(#clip0_9966_68965)">
            <path
              d="M43.3931 0H4.94143C2.2103 0 0 2.2103 0 4.94143V31.0586C0 33.7897 2.2103 36 4.94143 36H43.3994C46.1306 36 48.3409 33.7897 48.3409 31.0586V4.94143C48.3345 2.2103 46.1242 0 43.3931 0ZM18.7304 26.1108C18.7304 28.5307 18.2223 30.055 17.2188 30.6584C16.5328 31.0713 14.8751 31.2745 12.2837 31.2745C10.1623 31.2745 8.77135 30.9442 8.15526 30.2964C7.53917 29.6422 7.22159 28.2385 7.22159 26.1108V20.5152H12.1757V25.7551C12.1757 26.8793 12.6203 27.1143 12.9951 27.1143C13.2999 27.1143 13.6747 26.9555 13.7509 26.1807V5.90049H18.7304V26.1108ZM30.036 9.91461H27.5462V31.1729H22.5603V9.91461H20.0706V5.90049H30.0423V9.91461H30.036ZM39.6965 31.1729H31.7255V5.90049H36.6733V27.0127H39.7029V31.1729H39.6965Z"
              fill={'var(--base-shaftblue)'}
            />
            <path
              d="M18.7304 26.1108C18.7304 28.5307 18.2223 30.0551 17.2188 30.6585C16.5328 31.0713 14.8751 31.2745 12.2837 31.2745C10.1623 31.2745 8.77134 30.9443 8.15525 30.2964C7.53916 29.6422 7.22159 28.2386 7.22159 26.1108V20.5152H12.1757V25.7551C12.1757 26.8793 12.6203 27.1143 12.9951 27.1143C13.2999 27.1143 13.6747 26.9556 13.7509 26.1807V5.90051H18.7304V26.1108ZM30.036 9.91463H27.5462V31.1729H22.5603V9.91463H20.0706V5.90051H30.0423V9.91463H30.036ZM39.6965 31.1729H31.7255V5.90051H36.6732V27.0127H39.7029V31.1729H39.6965Z"
              fill={'var(--base-logo-white)'}
            />
          </g>
          <defs>
            <clipPath id="clip0_9966_68965">
              <rect width="48.3409" height="36" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

JTLLogo.displayName = 'JTLLogo';

export default JTLLogo;
